export const TRACKING_LINKS_COLUMNS = [
  { id: 'name', label: 'Name', alwaysVisible: true },
  { id: 'event', label: 'Event' },
  { id: 'type', label: 'Type' },
  { id: 'source', label: 'Source', defaultHidden: true },
  { id: 'medium', label: 'Medium', defaultHidden: true },
  { id: 'campaign', label: 'Campaign' },
  { id: 'visits', label: 'Visits' },
  { id: 'orders', label: 'Orders' },
  { id: 'tickets', label: 'Tickets' },
  { id: 'conversion_rate', label: 'Conv.', defaultHidden: true },
  { id: 'revenue', label: 'Revenue' },
];
